module.exports = __webpack_public_path__ + "img/A3-4-plan.91cc97a5.png";